import {
  AnyQuestionI,
  AnyTextQuestionI,
  CalculationQuestionI,
  MultiModelQuestionI,
  MultiReasonQuestionI,
  SimpleQuestionI
} from "@seneca/short-answer-service-types";

import { QuestionType } from "./common";

export function isSimpleQuestion(
  value: AnyQuestionI
): value is SimpleQuestionI {
  return !value.type || value.type === QuestionType.SIMPLE;
}

export function isMultiReasonQuestion(
  value: AnyQuestionI
): value is MultiReasonQuestionI {
  return value.type === QuestionType.MULTI_REASON;
}

export function isMultiModelQuestion(
  value: AnyQuestionI
): value is MultiModelQuestionI {
  return value.type === QuestionType.MULTI_MODEL;
}

export function isTextQuestion(value: AnyQuestionI): value is AnyTextQuestionI {
  return (
    isSimpleQuestion(value) ||
    isMultiReasonQuestion(value) ||
    isMultiModelQuestion(value)
  );
}

export function isCalculationQuestion(
  value: AnyQuestionI
): value is CalculationQuestionI {
  return value.type === QuestionType.CALCULATION;
}
